/**
 * @generated SignedSource<<1570601b9a481a72fe14a3a063183185>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type promoTracking_messages$data = {
  readonly items: ReadonlyArray<{
    readonly linkData: {
      readonly path: string | null;
    };
  } | null> | null;
  readonly " $fragmentType": "promoTracking_messages";
};
export type promoTracking_messages$key = {
  readonly " $data"?: promoTracking_messages$data;
  readonly " $fragmentSpreads": FragmentRefs<"promoTracking_messages">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "promoTracking_messages"
};

(node as any).hash = "b186ca7c88c2ed8c5da030092b5e2011";

export default node;
